import {IPreviewProps} from "./Preview";

export function AudioPreview({path}: IPreviewProps) {
    return (
        <audio key={path} controls>
            <source src={path}/>
        </audio>
    );
}
